/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
import React, {useEffect, useState} from 'react';
// material
import {
    displayModal, Button, Divider,
    Form, Grid, GridSet, GridItem,
    DayPickerDropDown,
    Accent, Switch, Tip, TextField, displayMessage
} from '@insticator/insticator-ui'; // iui-material
// styles
import injectSheet from 'react-jss';
import styles from './modal_styles';
import {useDispatch, useSelector} from "react-redux";
import {delegationMap} from "./constants";
import {fetchMcmAccountsData, saveMcmAccount} from "../../../../state/thunks/mcm";

/* ========== ~~~~~~~~~~ MCM MODAL~~~~~~~~~~ ========== */
const McmModal = injectSheet(styles)((props) => {

    const dispatch = useDispatch();
    const [childPublisher, setChildPublisher] = useState(props.childPublisher);
    const [mcmAccounts, setMcmAccounts] = useState(props.mcmAccounts);
    const [mcmAccount, setMcmAccount] = useState();
    const [overrideSwitch, setOverrideSwtich] = useState(props.childPublisher.overrideGamRevenueShare!=null);
    const [overrideGamShare, setOverrideGamShare] = useState(0);
    const [insticatorAccount, setInsticatorAccount] = useState("");
    const [approvalDate, setApprovalDate] = useState("0001-01-01");
    const [parentShare, setParentShare] = useState("-");
    const [childShare, setChildShare] = useState("-");
    const [overrideGamShareFlag, setOverrideGamShareFlag] = useState(false);
    const [approvalDateFlag, setApprovalDateFlag] = useState(false);
    const saveMcmAccountValidation = useSelector((state) => state.mcm.saveMcmAccountValidation);
    const [saveInProgress, setSaveInProgress] = useState(false);
    const permissions = useSelector((state) => state.session.permissions);
    const isPermissionToManageGlobalPlatformFees = permissions.includes('settings.managePlatformFees');

    useEffect(() => {
        let instAcc;
        let overrideGam;
        let appDate;
        for(let key in mcmAccounts) {
            if(mcmAccounts[key].childNetworkCode===childPublisher.childNetworkCode) {
                instAcc = mcmAccounts[key].displayName + " (" + mcmAccounts[key].accountUUID + ")";
                if(mcmAccounts[key].overrideGamRevenueShare!=null && !isNaN(mcmAccounts[key].overrideGamRevenueShare))
                    overrideGam = mcmAccounts[key].overrideGamRevenueShare;
                if(mcmAccounts[key].approvalDate!=null && mcmAccounts[key].approvalDate.length===10)
                    appDate =mcmAccounts[key].approvalDate;
                setMcmAccount(mcmAccounts[key]);
            }
        }
        if(instAcc!==undefined)
            setInsticatorAccount(instAcc);
        if(overrideGam!==undefined)
            setOverrideGamShare(overrideGam * 100);
        if(appDate!==undefined) {
            setApprovalDate(appDate);
        }
        if(childPublisher.gamRevenueShare) {
            setParentShare(childPublisher.gamRevenueShare * 100);
            setChildShare(100 - (childPublisher.gamRevenueShare * 100));
        }
    }, []);

    useEffect(()=>{
        let flag = true;
        if(saveMcmAccountValidation && "overrideGamShare" in saveMcmAccountValidation && saveMcmAccountValidation["overrideGamShare"]) {
            setOverrideGamShareFlag(true);
            flag = false;
        } else {
            setOverrideGamShareFlag(false);
        }
        if(saveMcmAccountValidation && "approvalDate" in saveMcmAccountValidation && saveMcmAccountValidation["approvalDate"]) {
            setApprovalDateFlag(true);
            flag = false;
        } else {
            setApprovalDateFlag(false);
        }
        if(saveInProgress && flag) {
            setSaveInProgress(false);
            setTimeout(()=>{dispatch(fetchMcmAccountsData())},1000);
            dispatch(displayModal(false));
            dispatch(displayMessage({
                type: 'toaster',
                close: true,
                variant: 'primary',
                time: 3000,
                align: 'top-right',
                message: <p>Account saved successfully</p>
            }));
        }
    }, [saveMcmAccountValidation]);

    const validate = () => {
        let result = true;
        if(overrideSwitch) {
            if(isNaN(overrideGamShare) || overrideGamShare < 0 || overrideGamShare > 100) {
                setOverrideGamShareFlag(true);
                result = false;
            } else {
                setOverrideGamShareFlag(false);
                result = true;
            }
        }
        if(isNaN(Date.parse(approvalDate))) {
            setApprovalDateFlag(true);
            result = false;
        } else {
            setApprovalDateFlag(false);
            result = true;
        }
        return result;
    }

    const handleCancel = () => {
        dispatch(displayModal(false));
    }

    const handleSave = () => {
        if(validate()) {
            let payload = {
                accountUUID: mcmAccount.accountUUID,
                approvalDate: approvalDate
            };
            if(overrideSwitch) {
                payload.overrideGamShare = overrideGamShare / 100;
            } else {
                payload.overrideGamShare = null;
            }
            setSaveInProgress(true);
            dispatch(saveMcmAccount(payload));
        } else {
            console.log("Form validation failed");
        }
    }

    return (
        <div className={props.classes.CustomModal}>
            <div>
                <h3>Edit MCM details</h3>
            </div>
            <Divider />
            <div>
                <Form formName='editMcmForm' >
                    <Grid>
                        <GridSet direction={`horizontal`}>
                            <GridItem>
                                Child information
                            </GridItem>
                            <GridItem>
                                <GridSet direction={`vertical`}>
                                    <GridItem>
                                        Child publisher name
                                    </GridItem>
                                    <GridItem>
                                        <Accent>
                                            <span>{childPublisher.childPublisher}</span>
                                        </Accent>
                                    </GridItem>
                                    <GridItem>
                                        Child seller ID
                                    </GridItem>
                                    <GridItem>
                                        <Accent>
                                            {
                                                childPublisher.sellerId
                                                    ?
                                                    <span>{childPublisher.sellerId}</span>
                                                    :
                                                    <span>-</span>
                                            }
                                        </Accent>
                                    </GridItem>
                                    <GridItem>
                                        Network code
                                    </GridItem>
                                    <GridItem>
                                        <Accent>
                                            <span>{childPublisher.childNetworkCode}</span>
                                        </Accent>
                                    </GridItem>
                                </GridSet>
                            </GridItem>
                        </GridSet>
                        <GridSet direction={`horizontal`}>
                            <GridItem>
                                Parent information
                            </GridItem>
                            <GridItem>
                                <GridSet direction={`vertical`}>
                                    <GridItem>
                                        Parent account
                                    </GridItem>
                                    <GridItem>
                                        <Accent>
                                            <span>{childPublisher.parentPublisher}</span>
                                        </Accent>
                                    </GridItem>
                                    <GridItem>
                                        <span>
                                            Insticator account
                                        </span>
                                        <Tip space={'right'}
                                             icon={'question-circle'}
                                             content={
                                                 <p>This is important for reporting purposes, and ensures any changes made such as rev share override are applied to the correct account.</p>
                                             }
                                        />
                                    </GridItem>
                                    <GridItem>
                                        <Accent>
                                            {
                                                insticatorAccount
                                                    ?
                                                    <span>{insticatorAccount}</span>
                                                    :
                                                    <span>-</span>
                                            }
                                        </Accent>
                                    </GridItem>
                                </GridSet>
                            </GridItem>
                        </GridSet>
                        <GridSet direction={`horizontal`}>
                            <GridItem>
                                Delegation
                            </GridItem>
                            <GridItem>
                                <GridSet direction={`vertical`}>
                                    <GridItem>
                                        Delegation type
                                    </GridItem>
                                    <GridItem>
                                        <Accent>
                                            <span>{childPublisher.delegation}</span>
                                        </Accent>
                                    </GridItem>
                                    {
                                        childPublisher.delegation===delegationMap.MANAGE_ACCOUNT
                                        &&
                                        <div>
                                            <GridItem>
                                                Parent/child rev share on GAM
                                            </GridItem>
                                            <GridItem>
                                                <Accent>
                                            <span>
                                                {parentShare}% / {childShare}%
                                            </span>
                                                </Accent>
                                            </GridItem>
                                            <GridItem>
                                                <div className={props.classes.Inline1}>
                                                    <Switch on={overrideSwitch}
                                                            handleClick={
                                                                function(){
                                                                    setOverrideSwtich(!overrideSwitch);
                                                                }
                                                            }
                                                            isStatic={!insticatorAccount}
                                                    />
                                                </div>
                                                <div className={props.classes.Inline2}>
                                                    <span>
                                                        Override rev share on GAM
                                                    </span>
                                                    <Tip space={'right'}
                                                         icon={'question-circle'}
                                                         content={
                                                             <p>Enable this in order override the revenue share that is set on GAM with whatever you indicate below. This will only affect the calculations for reporting. This will NOT affect the actual payout distributed by GAM.</p>
                                                         }
                                                    />
                                                </div>
                                            </GridItem>
                                            <GridItem>
                                                <div className={props.classes.Inline1}>
                                                    <TextField type={'number'}
                                                               disabled={!overrideSwitch}
                                                               value={overrideGamShare}
                                                               handleChange={e => setOverrideGamShare(e.target.value)}
                                                    />
                                                </div>
                                                <div className={props.classes.Inline2}>
                                                    % to parent and {100 - overrideGamShare}% to child
                                                </div>
                                                {
                                                    overrideGamShareFlag
                                                    &&
                                                    <span className={props.classes.Error}>
                                                        Invalid entry
                                                    </span>
                                                }
                                            </GridItem>
                                        </div>
                                    }
                                </GridSet>
                            </GridItem>
                        </GridSet>
                        <GridSet direction={`horizontal`}>
                            <GridItem>
                                Invitation details
                            </GridItem>
                            <GridItem>
                                <GridSet direction={`vertical`}>
                                    <GridItem>
                                        Status
                                    </GridItem>
                                    <GridItem>
                                        <Accent>
                                            <span>{childPublisher.status}</span>
                                        </Accent>
                                    </GridItem>
                                    {
                                        insticatorAccount
                                        &&
                                        <div>
                                            <GridItem>
                                                Approval date on GAM
                                            </GridItem>
                                            <GridItem>
                                                <DayPickerDropDown selectedDay={approvalDate}
                                                                   selectDay={
                                                                       function(item){setApprovalDate(item)}
                                                                   }
                                                                   disabledDates={[]}
                                                />
                                                {
                                                    approvalDateFlag
                                                    &&
                                                    <span className={props.classes.Error}>
                                                        Invalid date
                                                    </span>
                                                }
                                            </GridItem>
                                        </div>
                                    }
                                </GridSet>
                            </GridItem>
                        </GridSet>
                    </Grid>
                </Form>
            </div>
            <Divider />
            <div className={props.classes.Footer}>
                <Button variant={'normal'} text={'Cancel'} type={'action'} handleClick={handleCancel}/>
                <Button variant={'normal'} text={'Save'} type={'action'} disabled={!insticatorAccount || !isPermissionToManageGlobalPlatformFees} handleClick={handleSave}/>
            </div>
        </div>
    );
});

/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default injectSheet(styles)(McmModal);